import React from "react";
import Modal from "react-bootstrap/Modal";
import "./AlertBox.css";
import Button from "../ButtonComponent/Button";
import PropTypes from "prop-types";

const AlertBox = ({
  show,
  setShow,
  title,
  alertMessage,
  className,
  buttonSubmitText = "OK",
  alertFunc = () => {
    setShow(false);
  },okFunction
}) => {
  const handleClose = () => setShow(false);

  return (
    <div>
      <Modal show={show} onHide={handleClose} className="alertBox" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{alertMessage}</Modal.Body>
        <Modal.Footer>
          <Button
            className={`${className}`}
            text={buttonSubmitText}
            onClick={() => {alertFunc(); if(okFunction) okFunction()}}
          ></Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

AlertBox.proptype = {
  setShow: PropTypes.func,
  show: PropTypes.bool,
  title: PropTypes.string,
  alertMessage: PropTypes.string,
  buttonSubmitText: PropTypes.string,
};
export default AlertBox;
